import {useState, useEffect, useContext} from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import {MapContainer, Marker, Popup, TileLayer, useMapEvents} from "react-leaflet";
import {useTranslation} from "react-i18next";

import AuthContext from "context/AuthContext";
import {publishEvent} from "core/eventsConnector";
import {MarkerIcon} from "components/waste-icons";
import {CARTO_TILE_URL, CARTO_TILE_OPTIONS} from 'core/mapsConfig';

const MapModal = ({show, setShow, title = "Mapa", initialLat = null, initialLng = null, onPositionSelect = null}) => {
    const {panel} = useContext(AuthContext);
    const [location, setlocation] = useState(null);
    const [mapCenter, setMapCenter] = useState(null);

    const {t: _Tf} = useTranslation("forms");

    useEffect(() => {
        if (show && initialLat && initialLng) {
            const position = [parseFloat(initialLat), parseFloat(initialLng)];
            setlocation(position);
            setMapCenter(position);
        } else if (show && panel.coords) {
            setMapCenter(panel.coords);
        }
    }, [show, initialLat, initialLng, panel.coords]);

    const handleMapClick = (e) => {
        const {lat, lng} = e.latlng;
        const newPosition = [lat, lng];
        setlocation(newPosition);
    };

    const MapClickHandler = () => {
        useMapEvents({
            click: handleMapClick,
        });
        return null;
    };

    const handleAccept = () => {
        if (location) {
            publishEvent("mapmodal:position:selected", {
                lat: location[0],
                lng: location[1],
            });

            if (onPositionSelect) {
                onPositionSelect(location[0], location[1]);
            }
        }
        setShow(false);
    };

    const handleClose = () => {
        setShow(false);
    };

    return (
        <Modal
            show={show}
            //size="lg"
            fullscreen={true}
            onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Seleccionar ubicación: {title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-3">
                    <p className="text-muted">Haz click en el mapa para seleccionar una posición.</p>
                </div>
                <div>
                    {mapCenter && (
                        <MapContainer center={mapCenter} zoom={16} style={{height: "calc(100vh - 180px)", width: "100%"}}>
                            <TileLayer
                                url={CARTO_TILE_URL}
                                {...CARTO_TILE_OPTIONS}
                            />
                            <MapClickHandler />
                            {location && (
                                <Marker position={location} icon={MarkerIcon}>
                                    <Popup>
                                        <div>
                                            <strong>Posición seleccionada</strong>
                                            <br />
                                            Lat: {location[0].toFixed(6)}
                                            <br />
                                            Lng: {location[1].toFixed(6)}
                                        </div>
                                    </Popup>
                                </Marker>
                            )}
                        </MapContainer>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    {_Tf("labels.cancel")}
                </Button>
                <Button variant="primary" onClick={handleAccept} disabled={!location}>
                    {_Tf("labels.save")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
export default MapModal;
